import Button from 'tio-reimagined/components/button';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { NotificationsService } from 'tio-reimagined/components/notifications';
import { PhFiles } from 'ember-phosphor-icons';

export interface UiCopyButtonSignature {
  Element: HTMLElement;
  Args: {
    text: string;
    title?: string;
  };
}
class UiCopyButtonComponent extends Component<UiCopyButtonSignature> {
  @service declare notifications: NotificationsService;

  get text(): string {
    return this.args.text;
  }

  copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(this.text);
      this.notifications.add('Copied to clipboard', {
        appearance: 'success',
      });
    } catch (e) {
      this.notifications.add('Copy Failed', {
        appearance: 'error',
      });
      console.error(e);
    }
  };

  <template>
    <Button
      data-test-copy-button
      @intent="primary"
      @appearance="outlined"
      title={{@title}}
      {{on "click" this.copyToClipboard}}
      ...attributes
    >
      <PhFiles @size="16" />
    </Button>
  </template>
}

export default UiCopyButtonComponent;
